import { RefObject, useEffect, useState } from 'react';

type UsePlacementProps = {
    wrapperRef: RefObject<HTMLDivElement | null>;
};

const usePlacement = ({ wrapperRef }: UsePlacementProps): Position => {
    const [position, setPosition] = useState<Position>('relative');

    useEffect(() => {
        const wrapper = wrapperRef.current;

        if (!wrapper) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                const isWrapperEntirelyVisible = entry.intersectionRatio === 1;

                if (isWrapperEntirelyVisible) {
                    setPosition('relative');

                    return;
                }

                const boundingRect = entry.boundingClientRect;
                const elementMidpoint = boundingRect.top + boundingRect.height / 2;
                const screenMidpoint = window.innerHeight / 2;

                const shouldStickOnTop = elementMidpoint < screenMidpoint;

                setPosition(shouldStickOnTop ? 'top' : 'bottom');
            },
            {
                threshold: [0, 1]
            }
        );

        observer.observe(wrapper);

        return () => observer.disconnect();
    }, [wrapperRef]);

    return position;
};

type Position = 'top' | 'bottom' | 'relative';

export default usePlacement;
